import React, { useEffect, useState } from "react";
import img1 from "url:../../../assets/helpbanner1.jpg";
import img2 from "url:../../../assets/helpbanner2.jpg";
import img3 from "url:../../../assets/helpbanner3.jpg";
const images = [img1, img2, img3];
const headlines = ["Need help deciding?", "Too many options?"];

export default function HelpBanner() {
  const [image] = useState(images[Math.floor(Math.random() * images.length)]);
  const [headline] = useState(headlines[Math.floor(Math.random() * headlines.length)]);

  return (
    <div className="help-banner">
      <div className="help-banner-image">
        <img src={image} alt="" />
      </div>
      <div className="help-banner-content">
        <div className="help-banner-text">
          <h3 className="h2">{headline}</h3>
          <span className="bold">Talk to a 211 Navigator 24/7:</span>
        </div>
        <div className="help-links">
          <a className="help-link icon-phone-white" href="tel:211">
            <div className="help-link-text">
              Call{" "}
              <span className="hide-narrow" aria-hidden>
                2-1-1
              </span>
              <span className="visually-hidden">2-1-1</span>
            </div>
          </a>
          <button
            className="help-link icon-chat-white"
            onClick={(e) => {
              e.preventDefault();
              if (!document.querySelector(".wallet-card-chat")?.classList.contains("is-shown")) {
                window.dispatchEvent(new Event("openChatWallet"));
              }
            }}
          >
            Live Chat
          </button>
          <a className="help-link icon-text-white" href="sms:211">
            <div className="help-link-text">
              Text{" "}
              <span className="hide-narrow" aria-hidden>
                2-1-1
              </span>
              <span className="visually-hidden">2-1-1</span>
            </div>
          </a>
          <a className="help-link icon-email-white" href="/contact-us/#email">
            <div className="help-link-text">
              <span>Email </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
